import CircularLoader from '../Circular';
import { Box } from '@mui/material';

interface IPageLoader {
  /**
   * Whether to take page height or the parent height
   */
  isFullHeight?: boolean;

  /**
   * The size to modify the circular loaders ize
   */
  size?: number;
}

const PageLoader = ({ isFullHeight = true, size }: IPageLoader): JSX.Element => {
  return (
    <Box sx={{ height: isFullHeight ? '100vh' : '100%' }}>
      <CircularLoader size={size} />
    </Box>
  );
};

export default PageLoader;
